// The list asks only for what the table and its keyword search read, and pages
// with users-api's limit/nextToken (UserConnection). Unpaged, users-api drains
// every user up to 600 and then ERRORS, so the list must page.
export const listUsers = `
   query listUsers($filter: UsersFilterInput, $limit: Int, $nextToken: String) {
       listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              accountId
              email
              familyName
              givenName
              name
              status
              username
              sub
              created
              updated
           }
           nextToken
       }
   }
`;


export const getUser = `
   query getUser($username:ID!) {
       getUser(username:$username) {
          accountId
          accountAdmin
          address 
          birthDate
          email
          emailVerified
          enabled
          familyName
          gender
          givenName
          locale
          middleName
          name
          nickname
          phoneNumber
          phoneNumberVerified
          picture
          profile
          status
          username
          website
          zoneInfo
          sub
          created
          updated
       } 
}`;
